/**
 * @generated SignedSource<<6a62cc27130243d03242a5f5bc30151b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type sprint_nativeIssueTable_SprintCell$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef">;
  readonly " $fragmentType": "sprint_nativeIssueTable_SprintCell";
};
export type sprint_nativeIssueTable_SprintCell$key = {
  readonly " $data"?: sprint_nativeIssueTable_SprintCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"sprint_nativeIssueTable_SprintCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "sprint_nativeIssueTable_SprintCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef"
    }
  ],
  "type": "JiraSprintField"
};

(node as any).hash = "a6a38290e680b03dbe7f0c69af281f9c";

export default node;
